export const LOGIN_MFA_REQUESTING = 'LOGIN_MFA_REQUESTING'
export const LOGIN_MFA_SUCCESS = 'LOGIN_MFA_SUCCESS'
export const LOGIN_MFA_ERROR = 'LOGIN_MFA_ERROR'
export const LOGIN_MFA_URL = '/api/v1/users/mfaauthen'
export const LOGIN_MFA_REDIRECT = '/#/dashboard'


// WEBPACK FOOTER //
// ./src/views/Pages/LoginMfa/constants.js